import type { RecentCalcTool } from 'atoms/recentCalcsAtom';

// 画面移動コマンドの定義（SideNav の menuItems と同じ全 route を網羅する）。
// perform は呼び出し側(CommandPalette)で束ねるため、ここでは静的データのみ保持する。
export interface NavCommandDef {
    id: string;
    tool: RecentCalcTool;
    title: string;
    keywords: string; // 検索用の追加語（英語別名など）
    path: string;
}

export const NAV_COMMANDS: NavCommandDef[] = [
    { id: 'nav-r-new', tool: 'r', title: 'R: 新規計算セット作成', keywords: 'r new project create 新規', path: '/r-tools/new-project' },
    { id: 'nav-r-data', tool: 'r', title: 'R: データ登録', keywords: 'r data registration 登録', path: '/r-tools/data-registration' },
    { id: 'nav-r-existing', tool: 'r', title: 'R: 計算セット選択', keywords: 'r existing project select 選択', path: '/r-tools/existing-project' },
    { id: 'nav-r-calc', tool: 'r', title: 'R: 計算', keywords: 'r calculation 計算', path: '/r-tools/calculation' },
    { id: 'nav-r-cabin', tool: 'r', title: 'R: 室内音計算モード', keywords: 'r cabin noise 室内音', path: '/r-tools/cabin-noise' },
    { id: 'nav-r-mtg', tool: 'r', title: 'R: MTG先端振動計算モード', keywords: 'r mtg vibration 振動', path: '/r-tools/mtg-vib' },
    { id: 'nav-l-new', tool: 'l', title: 'L: 新規計算セット作成', keywords: 'l new project create 新規', path: '/l-tools/new-project' },
    { id: 'nav-l-data', tool: 'l', title: 'L: データ登録', keywords: 'l data registration 登録', path: '/l-tools/data-registration' },
    { id: 'nav-l-existing', tool: 'l', title: 'L: 計算セット選択', keywords: 'l existing project select 選択', path: '/l-tools/existing-project' },
    { id: 'nav-l-calc', tool: 'l', title: 'L: 計算', keywords: 'l calculation 計算', path: '/l-tools/calculation' },
    { id: 'nav-l-matrix', tool: 'l', title: 'L: 達成度判断表', keywords: 'l matrix 達成度 判断表', path: '/l-tools/matrix' },
];

// 検索対象を持つコマンドの共通形（画面移動 / 直近計算セット / 表示トグル）。
export interface CommandItem {
    id: string;
    title: string;
    group: string;
    keywords?: string;
}

// title / group / keywords への大文字小文字無視・空白区切り全語 AND の部分一致。
export const matchCommand = (cmd: CommandItem, query: string): boolean => {
    const haystack = `${cmd.title} ${cmd.group} ${cmd.keywords ?? ''}`.toLowerCase();
    return query
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .every((term) => haystack.includes(term));
};

// query 空のときは全件（恒等）。それ以外は matchCommand で絞り込む。
export const filterCommands = <T extends CommandItem>(commands: T[], query: string): T[] => {
    if (!query.trim()) return commands;
    return commands.filter((c) => matchCommand(c, query));
};
